<template>
  <div class="ly_chart">
    <table>
      <tr><td></td><td>{{skills.omoi}}</td><td></td></tr>
      <tr><td><div v-html="skills.syutai.split('').join('<br/>')"></div></td>
      <td><canvas id="chart" width="300" height="300"></canvas></td><td><div v-html="skills.kyoutyou.split('').join('<br/>')"></div></td>
      </tr>
      <tr><td></td><td>{{skills.seiri}}</td><td></td></tr>
    </table>
  </div>
</template>

<script>
import { Chart } from 'chart.js'

export default {
  data: () => ({
    skills: {
      omoi: '自分の思いを表現するスキル',
      syutai: '主体的に関与するスキル',
      kyoutyou: '協調して支援するスキル',
      seiri: '自分の気持ちを整理するスキル',
    },
  }),
  methods: {
    createChart() {
      // Chart.defaults.global.defaultFontSize = '24';
      var chart = new Chart(this.ctx, {
        type: 'radar',
        data: {
          // フォントサイズの制御がうまく行かないため、チャートのラベルではなくHTML部分で描画する。
          // labels: [
          //   skills.omoi,
          //   skills.kyoutyou.split(''),
          //   skills.seiri,
          //   skills.syutai.split(''),
          // ],
          // ラベルは空文字を設定必要。
          labels:['', '', '', ''],
          datasets: [
            {
              label: '',
              // dataの順番はHTML部分と合わせる。
              data: [
                // 偏差値 = 得点 * 10 + 50
                this.$store.state.result.omoi * 10 + 50,
                this.$store.state.result.kyoutyou * 10 + 50,
                this.$store.state.result.seiri * 10 + 50,
                this.$store.state.result.syutai * 10 + 50,
              ],
              backgroundColor: 'RGBA(159,232,214, 0.5)',
              borderWidth: 1,
            },
          ],
        },
        options: {
          plugins: {
            legend: false,
            // legend: {
            //   labels: {
            //     // This more specific font property overrides the global property
            //     font: {
            //       size: 30
            //     }
            //   }
            // },
            tooltip: false,
          },
          scale: {
            r: {
              pointLabels: {
                fontSize: 32
              }
            },
            ticks: {
              beginAtZero: true,
              suggestedMin: 0,
              suggestedMax: 80,
              stepSize: 10,
            },
          },
        },
      })
      // console.log(chart)
    },
  },
  mounted() {
    this.ctx = document.getElementById('chart')
    this.createChart()
  },
}
</script>

<style scoped>
#canvas {
  display: block;
}

.ly_chart {
  width: 100%;
  height: 100%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 17px;
  font-size: 20px;
}

.ly_chart div {
  line-height: 1;
  margin: 10px 20px;
}
</style>
